import {
  DELETE_FLOOR_FAILURE,
  DELETE_FLOOR_LOADING,
  DELETE_FLOOR_SUCCESS,
  FETCH_FLOOR_FAILURE,
  FETCH_FLOOR_LOADING,
  FETCH_FLOOR_SUCCESS,
  UPDATE_FLOOR_FAILURE,
  UPDATE_FLOOR_LOADING,
  UPDATE_FLOOR_SUCCESS
} from '../Types/floorTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const floorReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_FLOOR_LOADING:
    case UPDATE_FLOOR_LOADING:
    case DELETE_FLOOR_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };

    case UPDATE_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'Floor updated successfully'
      };

    case DELETE_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Floor removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_FLOOR_FAILURE:
    case UPDATE_FLOOR_FAILURE:
    case DELETE_FLOOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default floorReducer;
